"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAdminCustomerList = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/customer/list");
const Actions = require("../../actions/customer/list");
const sok_types_1 = require("@caddigital/sok-types");
function parseQueryString(action) {
    return Object.entries(action.payload.opts)
        .map(([key, value]) => `${key}=${value !== undefined && encodeURIComponent(value.toString())}`)
        .join('&');
}
function fetchAdminCustomerList(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_CUSTOMER_LIST_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/customer/?${parseQueryString(action)}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .array(action.payload.type === 'ADMIN'
            ? sok_types_1.Customer.iExtendedCustomer
            : sok_types_1.Customer.iCustomer)
            .decode(response);
        const act = validation.fold((e) => Actions.fetchCustomerListFailed((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchCustomerListSuccess(action.payload.type, e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchCustomerListFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.fetchAdminCustomerList = fetchAdminCustomerList;
//# sourceMappingURL=list.js.map